<template>
  <div id="app">
    <div class="app__wrapper grid">
      <div class="app__container" ref="container">
        <div class="app__inner" :data-page="$route.name">
          <Loader
            v-if="!loaded"
          />
          <transition
            @enter="enter"
            @leave="leave"
            mode="in-out"
            appear
          >
            <router-view
              v-if="loaded"
              :js-page="$route.name"
              :key="$route.fullPath"
            />
          </transition>
        </div>
      </div>

      <aside class="left" data-anim="ui">
        <Header />
        <div class="aside__wrapper">
          <Scrollbar />
          <div class="aside__voice">
            <div class="rotate rotate--first">
              <transition-group tag="div" appear>
                <span key="intro" v-if="detail === null && $route.name === 'home'">Ciao</span>
                <span key="def" v-if="detail === null && $route.name !== 'home'"></span>
                <span
                  key="motorcycle"
                  v-if="loaded && detail !== null"
                  v-html="detail"
                />
              </transition-group>
            </div>
          </div>
          <div class="aside__voice">
            <router-link
              class="rotate"
              to="/manifesto"
            >
              <span><div class="fx">Manifesto</div></span>
            </router-link>
          </div>
        </div>
      </aside>

      <aside class="right" data-anim="ui">
        <div class="aside__wrapper">
          <div class="contact">
            <router-link class="rotate rotate--first" to="/contatti">
              <span><div class="fx">Contact</div></span>
            </router-link>
          </div>
          <div>
            <a
              href="https://instagram.com/pitokmotormuseum"
              target="_blank"
              rel="noopener"
              class="rotate"
            >
            <span><div class="fx">@pitokmotormuseum</div></span>
            </a>
          </div>
        </div>
      </aside>
    </div>

    <Menu v-show="menu" />

    <Pointer />

    <Cookie v-if="loaded" />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
// import FontFaceObserver from 'fontfaceobserver';
import Medusa from '@adoratorio/medusa';
// import Apollo from '@adoratorio/apollo';
import { TweenMax, Expo } from 'gsap/TweenMax';
// import aion from '@/scripts/aion';
import hades from '@/scripts/hades';
import medusa from '@/scripts/medusa';
import apollo from '@/scripts/apollo';

import { animations, initial, transition } from '@/animations';
import Header from '@/components/ui/Header.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Loader from '@/components/Loader.vue';
import Menu from '@/components/ui/Menu.vue';
import Pointer from '@/components/ui/Pointer.vue';
import Cookie from '@/components/Cookie.vue';

export default {
  name: 'App',

  components: {
    Header,
    Scrollbar,
    Loader,
    Menu,
    Pointer,
    Cookie,
  },

  data() {
    return {
      first: true,
      menuAnim: null,
      trans: {
        enter: null,
        leave: null,
        type: 'default',
      },

      duration: 0,

      fonts: [{
        name: 'Canela',
        weight: 300,
      }, {
        name: 'Canela',
        weight: 400,
      }, {
        name: 'Canela',
        weight: 700,
      }],
    };
  },

  computed: {
    ...mapGetters({
      loaded: 'getLoaded',
      detail: 'getDetail',
      menu: 'getMenu',
      nextType: 'getNextType',
    }),
  },

  watch: {
    // loaded(n) {
    //   if (n) {
    //     console.log('n: ', n);
    //   }
    // },

    menu(n) {
      if (n) {
        hades.ref.pause();
        // if (utils.isTouchDevice()) disableBodyScroll(document.querySelector('nav'));
      } else {
        hades.ref.play();
        // if (utils.isTouchDevice()) clearAllBodyScrollLocks();
      }
    },
  },

  mounted() {
    this.init();
    hades.init();
    medusa.init();

    // this.$el.addEventListener('intesectionTriggered', e => this.check(e));

    // const observers = [];
    // this.fonts.forEach((font) => {
    //   const obs = new FontFaceObserver(font.name, { weight: font.weight });
    //   observers.push(obs.load());
    // });
  },

  methods: {
    enter(el, done) {
      let delay = 0;

      hades.ref.pause();
      done();

      this.trans.enter = el.getAttribute('js-page');
      // eslint-disable-next-line
      const transName = this.trans.enter === 'motorcycle' && this.trans.leave === 'home' && window.innerWidth > 1024 ? 'motorcycle'
      // eslint-disable-next-line no-nested-ternary
        : this.trans.enter === 'motorcycle' && this.trans.leave === 'motorcycle' && window.innerWidth > 1024 ? this.nextType === 'next2' ? 'next2'
          : 'next'
          : 'default';

      if (transName === 'next2') delay = -500;

      if (this.trans.enter === 'contact') {
        const asides = Array.from(document.querySelectorAll('.aside__wrapper'));
        TweenMax.to(asides, this.first ? 0 : 0.6, {
          autoAlpha: 0,
          ease: Expo.easeOut,
        });
      }

      if (this.nextType === 'next2') {
        hades.ref.scrollTo({ x: 0, y: 0 }, 400);
      }

      setTimeout(() => {
        hades.ref.scrollTo({ x: 0, y: 0 }, 0);

        const els = this.first ? Array.from(document.querySelectorAll('[data-anim]:not([data-animated])')) : Array.from(el.querySelectorAll('[data-anim]:not([data-animated])'));
        this.checkMedusa(els);
        this.checkApollo();

        transition.get(`${transName}-in`)(el, done, this.first ? 1 : 0);
        this.init(el);

        this.first = false;
        this.$store.commit('NEXT_TYPE', 'default');
      }, (this.duration + delay));
    },

    leave(el, done) {
      this.trans.leave = el.getAttribute('js-page');

      // eslint-disable-next-line
      const transName = this.trans.leave === 'home' && this.$route.name === 'motorcycle' && window.innerWidth > 1024 ? 'motorcycle'
      // eslint-disable-next-line no-nested-ternary
        : this.trans.leave === 'motorcycle' && this.$route.name === 'motorcycle' && window.innerWidth > 1024 ? this.nextType === 'next2' ? 'next2'
          : 'next'
          : 'default';

      if (this.trans.leave === 'contact') {
        const asides = Array.from(document.querySelectorAll('.aside__wrapper'));
        TweenMax.to(asides, 0.6, {
          autoAlpha: 1,
          ease: Expo.easeOut,
        });
      }
      const trans = transition.get(`${transName}-out`)(el, done);

      this.duration = trans.duration() * 800;
    },

    init(ctx = this.$el) {
      Array.from(ctx.querySelectorAll('[data-anim]:not([data-animated])')).forEach((element) => {
        initial.get(element.dataset.anim)(element);
      });
    },

    check(e) {
      e.detail.target.dataset.view = e.detail.isIntersecting;
    },

    checkMedusa(els) {
      medusa.ref.internalTargets.forEach((target) => {
        if (target.id === 'enter-animation') medusa.ref.removeTarget(target.id);
      });

      this.$nextTick(() => {
        medusa.ref.addTarget({
          id: 'enter-animation',
          container: document.querySelector('#app'),
          nodes: els,
          mode: Medusa.MODE.ONCE,
          offsets: '0px 0px 0px 0px',
          callback: (entry) => {
            animations.get(entry.target.dataset.anim)(entry.target, entry.target.dataset.delay).play();
          },
        });
      });
    },

    checkApollo() {
      apollo.ref.removeTarget('apollo');
      apollo.ref.removeTarget('apollo-interactive');
      apollo.ref.removeTarget('apollo-magnetism');
      apollo.ref.removeTarget('apollo-gallery');
      const target = {
        id: 'apollo',
        elements: [...Array.from(document.querySelectorAll('a')), ...Array.from(document.querySelectorAll('.apollo__link'))],
        offset: {
          x: 0,
          y: 0,
        },
      };

      const targetInteractive = {
        id: 'apollo-interactive',
        elements: [...Array.from(document.querySelectorAll('.apollo__interactive'))],
        offset: {
          x: 0,
          y: 0,
        },
      };

      const targetGallery = {
        id: 'apollo-gallery',
        elements: [
          ...Array.from(document.querySelectorAll('.blueimp-gallery .next')),
          ...Array.from(document.querySelectorAll('.blueimp-gallery .prev')),
          ...Array.from(document.querySelectorAll('.blueimp-gallery .close')),
        ],
        offset: {
          x: 0,
          y: 0,
        },
      };

      apollo.ref.addTargets([target, targetInteractive, targetGallery]);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/base.scss";

body {
  overflow: hidden;

  @include mq($and: $is-touch-device) {
    max-width: 100vw;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
    overflow-x: hidden;
  }
}

#app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @include mq($and: $is-touch-device) {
    height: auto;
  }
}

.app__container {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: auto;
  min-height: 100%;

  @include mq($and: $is-touch-device) {
    position: relative;
    width: 100vw;
    height: auto;
    min-height: 0;
  }
}

.app__wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

aside {
  position: relative;
  z-index: 3;
  display: flex;
  flex-flow: column wrap;
  font-size: rem(15px);
  pointer-events: none;

  &.left {
    grid-column-start: 1;
    grid-column-end: 5;

    padding: rem(60px) rem(20px) rem(60px) rem(60px);

    mix-blend-mode: exclusion;

    .rotate span {
      background: RGB($color-bg);
    }

    @at-root body[data-theme="day"] & {
      mix-blend-mode: multiply;

      @media (prefers-color-scheme: dark) {
        mix-blend-mode: exclusion;
      }
    }

    /* @media (prefers-color-scheme: light) {
      mix-blend-mode: multiply;
    } */

    @include mq($until: ds) {
      grid-column-start: 1;
      grid-column-end: 4;
      padding: rem(60px) rem(20px) rem(60px) rem(20px);
    }

    @include mq($until: ipadP) {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;

      padding: rem(40px) 0;
    }

    .aside__wrapper {
      margin-top: rem(100px);
    }
  }

  &.right {
    grid-column-start: 29;
    grid-column-end: 33;

    padding: rem(160px) rem(60px) rem(60px) rem(20px);


    @include mq($until: ds) {
      grid-column-start: 30;
      grid-column-end: 33;
      padding: rem(160px) rem(20px) rem(60px) rem(20px);
    }

    @include mq($until: ipadP) {
      display: none;
    }
  }

  .aside {
    &__wrapper {
      position: relative;

      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-between;

      flex: 1 0 0;

      @include mq($until: ipadP) {
        display: none;
      }

      & > * {
        flex: 0 0 50%;
        flex-basis: calc(50% - #{rem(20px)});

        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;

        * {
          pointer-events: auto;
        }

        &.contact {
          justify-content: flex-start;
        }
      }
    }

    &__line {
      position: absolute;
      top: 0;
      left: 50%;
      width: 1px;
      height: 100%;
      background: $color-border;
    }
  }

  .rotate {
    width: 0;
    transform: rotate(-90deg) translateY(50%);
    transform-origin: 100% 100%;

    span {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      padding: 0 rem(30px) 0 0;
      line-height: 1em;
      white-space: nowrap;

      transform: translate3d(0, -50%, 0);
    }

    &--first {
      span {
        padding: 0 rem(30px);
      }
    }
  }
}

.app__inner {
  position: relative;
  min-height: 100vh;
  // grid-column-start: 5;
  // grid-column-end: 29;

  // padding: rem(60px) rem(40px);
}

@include mq($until: ipadP) {
  main:not([js-page="motorcycle"]) {
    padding-top: rem(94px);
  }
}

.container {
  grid-column-start: 4;
  grid-column-end: 30;

  @include mq(ipadP) {
    grid-column-start: 5;
    grid-column-end: 29;
  }

  &--small {
    grid-column-start: 4;
    grid-column-end: 30;

    @include mq(ipadP) {
      grid-column-start: 10;
      grid-column-end: 24;
    }
  }
}

main > .container,
nav > .container {
  @include mq(ipadP) {
    padding: 0 rem(60px);
  }
}

.fx {
  display: inline-block;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: RGB($color-text);

    transform: scaleX(0);
    transform-origin: 0% 50%;
    transition: all 0.4s ease-out;
  }


  &:hover {
    &::before {
      transform: scaleX(1);
    }
  }
}

p {
  position: relative;
}

.count-v-img {
  font-family: $font-family-base !important;
}
</style>
